(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		//this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class StickyMobileAddToCart extends HTMLElement {
        #root;
        #priceSlot;
        #button;
        #label;
        #targetButton;
        #priceSource;
        #io;
        #priceObserver;

        connectedCallback() {
            this.#root = this.querySelector('[data-sticky-mobile-atc="root"]');
            this.#priceSlot = this.querySelector('[data-sticky-mobile-atc="price"]');
            this.#button = this.querySelector('[data-sticky-mobile-atc="button"]');
            this.#label = this.querySelector('[data-sticky-mobile-atc="label"]');

            if (!this.#root || !this.#button) return;

            const scope = this.closest('section') || document;
            this.#targetButton = scope.querySelector('.product-form__submit[name="add"]');
            this.#priceSource = scope.querySelector('.price-wrapper[id^="price-"]');

            if (!this.#targetButton) {
                this.#hide();
                return;
            }

            this.#syncFromTarget();
            this.#button.addEventListener('click', this.#onClick);

            this.#io = new IntersectionObserver(this.#onIntersect, {
                root: null,
                threshold: 0.05,
            });
            this.#io.observe(this.#targetButton);

            if (this.#priceSource && this.#priceSlot) {
                this.#copyPrice();
                this.#priceObserver = new MutationObserver(() => this.#copyPrice());
                this.#priceObserver.observe(this.#priceSource, {
                    childList: true,
                    subtree: true,
                    characterData: true,
                    attributes: true,
                });
            }
        }

        disconnectedCallback() {
            this.#button?.removeEventListener('click', this.#onClick);
            this.#io?.disconnect();
            this.#priceObserver?.disconnect();
        }

        #onClick = () => {
            if (!this.#targetButton) return;
            this.#targetButton.click();
            this.#syncFromTarget();
        };

        #onIntersect = (entries) => {
            const entry = entries[0];
            if (!entry) return;

            this.#syncFromTarget();

            const shouldShow = !entry.isIntersecting && !this.#shouldAvoidConflicts();
            shouldShow ? this.#show() : this.#hide();
        };

        #shouldAvoidConflicts() {
            const scope = this.closest('section') || document;
            const stickyBar = scope.querySelector('.product__popup.sticky-bar');
            if (!stickyBar) return false;

            const style = window.getComputedStyle(stickyBar);
            if (style.display === 'none' || style.visibility === 'hidden') return false;

            const rect = stickyBar.getBoundingClientRect();
            return rect.height > 0 && rect.width > 0;
        }

        #show() {
            if (!this.#root) return;
            this.#root.style.transform = 'translateY(0)';
        }

        #hide() {
            if (!this.#root) return;
            this.#root.style.transform = 'translateY(100%)';
        }

        #syncFromTarget() {
            if (!this.#targetButton || !this.#button) return;

            const isDisabled = this.#targetButton.hasAttribute('disabled');
            if (isDisabled) {
                this.#button.setAttribute('disabled', '');
            } else {
                this.#button.removeAttribute('disabled');
            }

            const targetLabel = this.#targetButton.querySelector('span')?.textContent?.trim();
            if (targetLabel && this.#label) this.#label.textContent = targetLabel;
        }

        #copyPrice() {
            if (!this.#priceSource || !this.#priceSlot) return;
            this.#priceSlot.innerHTML = this.#priceSource.innerHTML;
        }
    }
    customElements.define('sticky-mobile-addtocart', StickyMobileAddToCart);

    class ProductModal extends ModalDialog {
        constructor() {
            super();

            this.isProductPage = true;
        }

        hide() {
            if (typeof window.destroyModalMobileSwiper === 'function') {
                window.destroyModalMobileSwiper(this);
            }
            super.hide(this.isProductPage);
            window.pauseAllMedia();
            // Resume autoplay videos on the product page after modal closes
            setTimeout(() => {
                document
                    .querySelectorAll('.product__media-list video[autoplay], .product__media-item video[autoplay]')
                    .forEach((video) => {
                        video.play().catch(() => {});
                    });
                // Also resume mobile gallery videos
                document.querySelectorAll('[data-mobile-main-slider] video').forEach((video) => {
                    video.play().catch(() => {});
                });
            }, 100);
        }

        show(opener) {
            super.show(opener);
            if (typeof window.initModalMobileSwiper === 'function') {
                window.initModalMobileSwiper(this, opener);
            }
            this.showActiveMedia();
        }

        showActiveMedia() {
            const mediaId = this.openedBy?.getAttribute('data-media-id');
            if (!mediaId) return;

            const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
            const isMobileModal = window.matchMedia('(max-width: 989px)').matches;

            if (!isMobileModal && activeMedia) {
                const mediaItem = activeMedia.closest('.product-media-modal__item');
                if (mediaItem) {
                    mediaItem.classList.add('active');
                    mediaItem.scrollIntoView();
                }
            }

            const deferredMedia = activeMedia?.closest('deferred-media');

            if (deferredMedia && deferredMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
                deferredMedia.loadContent();
            }
        }
    }

    customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
